import { constructionConstants } from "@constants/construction.constants";
import { constructionService } from "@services/construction.service";
import { msgTypes, showModal, householdUtil } from "@utils";
import { message } from "antd";
import _ from "lodash";
import { maskActions } from "./mask.actions";

let userLastFetchTimestamp = 0;
export const constructionActions = {
  getLoginInfo: constructionUuid => {
    return dispatch => {
      dispatch({
        type: constructionConstants.GET_LOGIN_INFO_REQUEST
      });

      constructionService.getLoginInfo(constructionUuid).then(
        loginInfo => {
          dispatch({
            type: constructionConstants.GET_LOGIN_INFO_SUCCESS,
            loginInfo
          });
        },
        error => {
          dispatch({
            type: constructionConstants.GET_LOGIN_INFO_FAILURE,
            error: error
          });
        }
      );
    };
  },
  /**
   * 變更登入密碼
   * @param {string} constructionUuid - 建案uuid
   * @param {object} info - 變更密碼資訊
   * @param {function} cbSuccess - 成功後的callback
   * @returns
   */
  changePassword: (constructionUuid, info, cbSuccess) => {
    return dispatch => {
      dispatch(maskActions.toggleMask(true));

      constructionService
        .changePassword(constructionUuid, info)
        .then(
          response => {
            showModal(msgTypes.SUCCESS, "通知", response, cbSuccess);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  /**
   * 取得建案資訊
   * @param {string} constructionUuid - 建案 uuid
   * @param {function} cbSuccess - 成功後的 callback
   * @returns
   */
  get: (constructionUuid, cbSuccess) => {
    return dispatch => {
      dispatch({
        type: constructionConstants.GET_EDIT_REQUEST
      });

      constructionService.get(constructionUuid).then(
        construction => {
          dispatch({
            type: constructionConstants.GET_EDIT_SUCCESS
          });
          cbSuccess && cbSuccess(construction);
        },
        error => {
          dispatch({
            type: constructionConstants.GET_EDIT_FAILURE,
            error: `取得建案資訊失敗：${error}`
          });
        }
      );
    };
  },
  /**
   * 重設建案資訊
   * @returns
   */
  resetGet: () => ({
    type: constructionConstants.RESET_GET_EDIT_SUCCESS
  }),
  /**
   * 取得建案管理費繳費方式清單
   * @param {string} constructionUuid - 建案 uuid
   * @param {function} cbSuccess - 成功後的 callback
   * @returns
   */
  getPaymentMethodList: (constructionUuid, cbSuccess) => {
    return dispatch => {
      dispatch({
        type: constructionConstants.GET_PAYMENT_METHOD_LIST_REQUEST
      });

      constructionService.getPaymentMethodList(constructionUuid).then(
        paymentMethods => {
          dispatch({
            type: constructionConstants.GET_PAYMENT_METHOD_LIST_SUCCESS,
            paymentMethods
          });
          cbSuccess && cbSuccess(paymentMethods);
        },
        error => {
          dispatch({
            type: constructionConstants.GET_PAYMENT_METHOD_LIST_FAILURE,
            error: `取得建案管理費繳費方式清單失敗：${error}`
          });
        }
      );
    };
  },
  /**
   * 取得車位格局清單
   * @param {function} cbSuccess - 成功後的 callback
   * @returns
   */
  getParkingSpacePatternList: cbSuccess => {
    return dispatch => {
      dispatch({
        type: constructionConstants.GET_PARKING_SPACE_PATTERN_LIST_REQUEST
      });

      constructionService.getParkingSpacePatternList().then(
        parkingSpacePatterns => {
          dispatch({
            type: constructionConstants.GET_PARKING_SPACE_PATTERN_LIST_SUCCESS,
            parkingSpacePatterns
          });
          cbSuccess && cbSuccess(parkingSpacePatterns);
        },
        error => {
          dispatch({
            type: constructionConstants.GET_PARKING_SPACE_PATTERN_LIST_FAILURE,
            error: `取得建案車位型態清單失敗：${error}`
          });
        }
      );
    };
  },
  /**
   * 重設建案資訊
   * @returns
   */
  resetGet: () => ({
    type: constructionConstants.RESET_GET_EDIT_SUCCESS
  }),
  /**
   * 取得建案事件資訊
   * @param {string} constructionUuid - 建案uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getEvents: (constructionUuid, condition) => {
    return dispatch => {
      dispatch({
        type: constructionConstants.GET_EVENTS_REQUEST
      });

      constructionService.getEvents(constructionUuid, condition).then(
        events => {
          dispatch({
            type: constructionConstants.GET_EVENTS_SUCCESS,
            events
          });
        },
        error => {
          dispatch({
            type: constructionConstants.GET_EVENTS_FAILURE,
            error: `取得建案事件失敗：${error}`
          });
        }
      );
    };
  },
  resetEvents: () => ({
    type: constructionConstants.RESET_GET_EVENTS_SUCCESS
  }),
  /**
   * 搜尋建案目標資訊
   * @param {string} constructionUuid - 建案uuid
   * @param {object} condition - 查詢條件
   * @param {function} cbSuccess - 成功後的callback
   * @returns
   */
  searchTarget: (constructionUuid, info, cbSuccess) => {
    return dispatch => {
      dispatch({
        type: constructionConstants.SEARCH_TARGET_REQUEST
      });

      constructionService.searchTarget(constructionUuid, info).then(
        response => {
          const transferdHouseholdList = householdUtil.sortHouseholds(response);

          dispatch({
            type: constructionConstants.SEARCH_TARGET_SUCCESS,
            items: transferdHouseholdList
          });

          cbSuccess && cbSuccess(transferdHouseholdList);
        },
        error => {
          message.error(error);
          dispatch({
            type: constructionConstants.SEARCH_TARGET_FAILURE,
            error
          });
        }
      );
    };
  },
  resetSearchTarget: () => ({
    type: constructionConstants.RESET_SEARCH_TARGET_SUCCESS
  }),
  /**
   * 儲存設定建案資訊
   * @param {string} constructionUuid - 建案uuid
   * @param {object} info - 設定資訊
   * @param {function} cbSuccess - 成功後的callback
   * @returns
   */
  setting: (constructionUuid, info, cbSuccess) => {
    return dispatch => {
      dispatch({
        type: constructionConstants.SETTING_REQUEST
      });

      constructionService.setting(constructionUuid, info).then(
        response => {
          dispatch({
            type: constructionConstants.SETTING_SUCCESS
          });

          cbSuccess && cbSuccess(response);
        },
        error => {
          dispatch({
            type: constructionConstants.SETTING_FAILURE,
            error
          });
        }
      );
    };
  },
  resetSetting: () => ({
    type: constructionConstants.RESET_SETTING_SUCCESS
  }),
  /**
   * 更新建案資訊
   * @param {string} constructionUuid - 建案uuid
   * @param {object} info - 設定資訊
   * @param {function} cbSuccess - 成功後的callback
   * @returns
   */
  update: (constructionUuid, info, cbSuccess) => {
    return dispatch => {
      dispatch(maskActions.toggleMask(true));

      constructionService
        .update(constructionUuid, info)
        .then(
          response => {
            showModal(msgTypes.SUCCESS, "通知", response, cbSuccess);
          },
          error => {
            showModal(msgTypes.ERROR, "錯誤", error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  /**
   * 刷新建案摘要資訊
   * @param {string} constructionUuid - 建案uuid
   * @param {function} cbSuccess - 成功後的callback
   * @returns
   */
  refreshSummaries: (constructionUuid, cbSuccess) => {
    return dispatch => {
      constructionService.getSummaries(constructionUuid).then(
        summaries => {
          dispatch({
            type: constructionConstants.REFRESH_SUMMARIES_SUCCESS,
            summaries
          });
          cbSuccess && cbSuccess(summaries);
        },
        error => {
          dispatch({
            type: constructionConstants.REFRESH_SUMMARIES_FAILURE,
            error: `取得建案清單失敗：${error}`
          });
        }
      );
    };
  },
  /**
   * 取得建案摘要資訊
   * @param {string} constructionUuid - 建案uuid
   * @param {function} cbSuccess - 成功後的callback
   * @returns
   */
  getSummaries: (constructionUuid, cbSuccess) => {
    return dispatch => {
      dispatch({
        type: constructionConstants.GET_SUMMARIES_REQUEST
      });

      constructionService.getSummaries(constructionUuid).then(
        summaries => {
          dispatch({
            type: constructionConstants.GET_SUMMARIES_SUCCESS,
            summaries
          });
          cbSuccess && cbSuccess(summaries);
        },
        error => {
          dispatch({
            type: constructionConstants.GET_SUMMARIES_FAILURE,
            error: `取得建案清單失敗：${error}`
          });
        }
      );
    };
  },
  resetSummaries: () => ({
    type: constructionConstants.RESET_SUMMARIES_SUCCESS
  }),
  /**
   * 取得建案戶別清單
   * @param {string} constructionUuid - 建案 uuid
   * @param {boolean} isReadUser - 是否取得住戶資訊
   * @param {function} cbSuccess - 成功後的callback
   * @returns
   */
  getHouseholdMeta: (constructionUuid, isReadUser = true, cbSuccess) => {
    return dispatch => {
      dispatch({
        type: constructionConstants.GET_HOUSEHOLD_META_REQUEST
      });

      constructionService
        .getHouseholdList(constructionUuid, {
          read_user: isReadUser ? 1 : 0
        })
        .then(
          householdList => {
            const transferdHouseholdList = householdUtil.transferHouseholdList(householdList);
            dispatch({
              type: constructionConstants.GET_HOUSEHOLD_META_SUCCESS,
              householdMeta: transferdHouseholdList
            });
            cbSuccess && cbSuccess(transferdHouseholdList);
          },
          error => {
            dispatch({
              type: constructionConstants.GET_HOUSEHOLD_META_FAILURE,
              error: `取得建案住戶資訊失敗：${error}`
            });
          }
        );
    };
  },
  resetHouseholdMeta: () => ({
    type: constructionConstants.RESET_HOUSEHOLD_META_SUCCESS
  }),
  /**
   * 取得建案包裹放置清單
   * @param {string} constructionUuid - 建案uuid
   * @param {function} cbSuccess - 成功後的callback
   * @returns
   */
  getStoreAreaList: (constructionUuid, cbSuccess) => {
    return dispatch => {
      dispatch({
        type: constructionConstants.GET_STORE_AREA_LIST_REQUEST
      });

      constructionService.getStoreAreaList(constructionUuid).then(
        storeAreas => {
          dispatch({
            type: constructionConstants.GET_STORE_AREA_LIST_SUCCESS,
            storeAreas
          });
          cbSuccess && cbSuccess();
        },
        error => {
          dispatch({
            type: constructionConstants.GET_STORE_AREA_LIST_FAILURE,
            error: `取得放置位置清單失敗：${error}`
          });
        }
      );
    };
  },
  /**
   * 重置建案包裹放置清單
   * @returns
   */
  resetStoreAreaList: () => ({
    type: constructionConstants.RESET_STORE_AREA_LIST_SUCCESS
  }),
  /**
   * 取得建案住戶摘要資訊
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @param {function} cbSuccess - 成功後的callback
   * @param {function} cbError - 失敗後的callback
   * @returns
   */
  getHouseholdSummaries: (constructionUuid, condition, cbSuccess, cbError) => {
    return dispatch => {
      dispatch(maskActions.toggleMask(true));
      constructionService
        .getHouseholdSummaries(constructionUuid, condition)
        .then(
          householdSummaries => {
            // 轉換資料格式
            const transferedHouseholdSummaries = {
              ...householdSummaries,
              target: {
                entity_type: householdSummaries.target_type,
                ...householdSummaries.target_info,
                household_id:
                  householdSummaries.target_type === "household"
                    ? householdSummaries.target_info.id
                    : null
              },
              items: householdSummaries.households
            };

            cbSuccess && cbSuccess(transferedHouseholdSummaries);
          },
          error => {
            cbError && cbError(error);
          }
        )
        .finally(() => {
          dispatch(maskActions.toggleMask(false));
        });
    };
  },
  /**
   * 取得使用者清單
   * @param {object} condition - 查詢條件
   * @param {number} execTimestamp - 執行時間戳記
   * @returns
   */
  getUserList: (condition, execTimestamp) => {
    userLastFetchTimestamp = execTimestamp;
    return dispatch => {
      dispatch({
        type: constructionConstants.GET_USER_LIST_REQUEST
      });

      constructionService.getUserList(condition).then(
        users => {
          dispatch({
            type: constructionConstants.GET_USER_LIST_SUCCESS,
            users
          });
        },
        error => {
          dispatch({
            type: constructionConstants.GET_USER_LIST_FAILURE,
            error: `取得使用者清單失敗：${error}`
          });
        }
      );
    };
  },
  /**
   * 重置使用者清單
   */
  resetUserList: () => ({
    type: constructionConstants.RESET_USER_LIST_SUCCESS
  }),
  /**
   * 取得車位清單
   * @param {string} constructionUuid - 建案 uuid
   * @param {object} condition - 查詢條件
   * @returns
   */
  getParkingSpaceList: (constructionUuid, condition) => {
    return dispatch => {
      dispatch({
        type: constructionConstants.GET_PARKING_SPACE_LIST_REQUEST
      });

      constructionService.getParkingSpaceList(constructionUuid, condition).then(
        parkingSpaces => {
          dispatch({
            type: constructionConstants.GET_PARKING_SPACE_LIST_SUCCESS,
            parkingSpaces
          });
        },
        error => {
          dispatch({
            type: constructionConstants.GET_PARKING_SPACE_LIST_FAILURE,
            error: `取得車位清單失敗：${error}`
          });
        }
      );
    };
  },
  /**
   * 重置車位清單
   */
  resetPakringSpaceList: () => ({
    type: constructionConstants.RESET_PARKING_SPACE_LIST_SUCCESS
  })
};
